module.exports = __webpack_public_path__ + "media/images/kml_logo-4c8bb6185b2a961631e2a9574cccacc4.png";